import { Button } from "@design-lab/shared/ui";
import { useTab } from "@design-lab/shared/ui/layouts/state";
import { ChevronRight } from "lucide-react";

type NextButtonProps = {
  className?: string;
};

export function NextButton(props: NextButtonProps) {
  const { className } = props;
  const { nextTab, isValid, canGoNext, next } = useTab();

  if (!canGoNext || !nextTab) return null;

  return (
    <Button
      data-testid="next-button"
      variant="destructive"
      className={className ?? ""}
      isDisabled={!isValid}
      onPress={next}
    >
      Next: {nextTab.mobileTitle} <ChevronRight />
    </Button>
  );
}
